import { Link } from "react-router-dom";

import { AiOutlineUserAdd } from "react-icons/ai";

export default function TourCard({ tour, colors, deleteTour, reservation }) {
  return (
    <div className={`col-lg-3 col-md-4 col-sm-6`} key={tour.id}>
      <div className={`card border-${colors[0]} m-1 mt-3 height-180`}>
        <div
          className={`card-header bg-${colors[0]} d-flex justify-content-between`}
        >
          <div>
            عنوان تور:
            <span className="txt"> {tour.title} </span>
          </div>
          {reservation ? (
            <div
              className="cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#sign-up-user"
              style={{ cursor: "pointer" }}
            >
              <AiOutlineUserAdd
                data-bs-toggle="tooltip"
                title="ثبت نام"
              ></AiOutlineUserAdd>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={`card-body bg-${colors[1]}`}>
          <div>
            تاریخ:
            <span className="txt"> {tour.duration} </span>
          </div>
          <div className="mt-2">
            {tour.transferType != "" ? (
              <>
                ترنسفر:
                <span className="txt"> {tour.transferType} </span>
              </>
            ) : (
              <br />
            )}
          </div>
          {reservation ? (
            <div className="buttons d-flex justify-content-evenly mt-3">
              <button
                className="btn mx-2 p-1"
                style={{
                  fontSize: "13px",
                  border: "1px solid lightblue",
                  borderRadius: "5px",
                }}
              >
                لیست تور لیدر
              </button>
              <button
                className="btn mx-2 p-1"
                style={{
                  fontSize: "13px",
                  border: "1px solid lightblue",
                  borderRadius: "5px",
                }}
              >
                لیست بیمه
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
        {!reservation ? (
          <div
            className={`card-footer bg-${colors[0]} d-flex justify-content-evenly`}
          >
            <Link
              to={`/tak-tour/${tour.id}`}
              data-bs-toggle="tooltip"
              title="مشاهده جزئیات"
              target="_blank"
            >
              <img
                alt="not found"
                src="/image/eye.svg"
                className="cursor-pointer"
              />
            </Link>
            <div
              data-bs-toggle="tooltip"
              title="حذف"
              style={{ cursor: "pointer" }}
            >
              <img
                alt="not found"
                src="/image/trash.svg"
                className="cursor-pointer"
                onClick={() => deleteTour(tour.id)}
              />
            </div>
            <Link
              to={`/admin-panel/create-tour/${tour.id}`}
              data-bs-toggle="tooltip"
              title="ویرایش"
              target="_blank"
            >
              <img
                alt="not found"
                src="/image/pencil-square.svg"
                className="cursor-pointer"
              />
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
